import { FlightDuration } from 'src/WebApiController';

export const PERCENT_OF_UNSOLD_COST_TO_DEFAULT_BUDGET = 0.02; // 2%

export const getProspectiveBudget = (
  unsoldCst: number | undefined,
  duration: FlightDuration,
  eventStartDate?: string | null
): number | null | undefined => {
  const daysToEvent = eventStartDate
    ? Math.floor(
        (new Date(eventStartDate).getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
      )
    : 0;

  if (!unsoldCst || daysToEvent <= 0) {
    return null;
  }

  const dailyBudget =
    (unsoldCst * PERCENT_OF_UNSOLD_COST_TO_DEFAULT_BUDGET) / daysToEvent; // 2% of unsold cost divided by days to event

  switch (duration) {
    case FlightDuration.Daily:
      return Math.max(Math.round(dailyBudget), 1);
    case FlightDuration.Weekly:
      return Math.max(Math.round(dailyBudget * 7), 1);
    case FlightDuration.Monthly:
      return Math.max(Math.round(dailyBudget * 30), 1);
    default:
      return null;
  }
};
